import "./LimitedDrops.module.css";
import Header from "@/reusable_sections/Header";
import CurrentExclusives from "./sections/CurrentExclusives";
import FutureReleaseCalendar from "./sections/FutureReleaseCalendar";
import TheStrideFooter from "@/reusable_sections/Footer";
export default function LimitedDropsPage() {
  return <div>
      <Header />
      <CurrentExclusives />
      <FutureReleaseCalendar />
      <TheStrideFooter />
    </div>;
}